<template>
  <transition
    :name="transitionName"
    mode="out-in"
  >
    <slot />
  </transition>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  direction?: 'slide-right' | 'slide-left';
}

const props = withDefaults(defineProps<Props>(), {
  direction: 'slide-right'
});

const transitionName = computed(() => props.direction);
</script>

<style scoped>
/* Slide right transition (default - going forward) */
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.3s ease;
}

/* Entering from right (new content slides in from right) */
.slide-right-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

/* Leaving to left (old content slides out to left) */
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

/* Entering from left (new content slides in from left) */
.slide-left-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}

/* Leaving to right (old content slides out to right) */
.slide-left-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
